
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, Map, Compass } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { Helmet } from 'react-helmet';

const NotFound = () => {
  const location = useLocation();
  const { t, language } = useLanguage();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
<Helmet>
  <title>{language === 'de' ? 'Seite nicht gefunden' : 'Page Not Found'} | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin</title>
  <meta name="description" content={language === 'de'
    ? 'Diese Seite existiert nicht. Bitte besuchen Sie die Startseite von Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin.'
    : 'This page does not exist. Please visit the homepage of Matthias Meyfarth – videographer, photographer, and web designer from Berlin.'} />
  <meta property="og:title" content={language === 'de'
    ? 'Seite nicht gefunden | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin'
    : 'Page Not Found | Matthias Meyfarth – Videograf, Fotograf & Webdesigner from Berlin'} />
  <meta property="og:description" content={language === 'de'
    ? 'Diese Seite existiert nicht. Zurück zur Startseite.'
    : 'This page does not exist. Back to homepage.'} />
  <meta property="og:type" content="website" />
</Helmet>
      <div className="text-center px-6 max-w-lg">
        <div className="mb-8 w-full max-w-[300px] mx-auto">
          <img 
            src="/lovable-uploads/d523bcf6-9851-4027-811a-0587d4e7bc20.png" 
            alt="Lost Photographer" 
            className="w-full h-auto opacity-70 rounded-lg shadow-lg"
          />
        </div>
        
        <h1 className="text-7xl font-bold text-primary mb-4">404</h1>
        
        {language === 'en' ? (
          <>
            <p className="text-2xl font-semibold mb-2">Oops! This shot didn't develop</p>
            <p className="text-lg text-gray-600 mb-8">
              Looks like our camera couldn't capture this page. Perhaps it was overexposed? 
              Or maybe it's just hiding in the dark room, waiting to be developed.
            </p>
          </>
        ) : (
          <>
            <p className="text-2xl font-semibold mb-2">Ups! Dieser Schnappschuss wurde nicht entwickelt</p>
            <p className="text-lg text-gray-600 mb-8">
              Sieht aus, als könnte unsere Kamera diese Seite nicht erfassen. Vielleicht war sie überbelichtet?
              Oder sie versteckt sich in der Dunkelkammer und wartet darauf, entwickelt zu werden.
            </p>
          </>
        )}
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="gap-2">
            <Link to="/">
              <Home className="h-4 w-4" />
              <span>{t('Back to Homepage')}</span>
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="gap-2">
            <Link to="/contact">
              <Compass className="h-4 w-4" />
              <span>{t('Contact Us')}</span>
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
